import "./Purchase.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import ChooseYourFlavr from "./sections/ChooseYourFlavr";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function PurchasePage() {
  return <div>
      <AutoMotiGalvene />
      <GetInTouch />
      <ChooseYourFlavr />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}